import { Routes } from '@angular/router';
import { RoleGuard } from '@guards/role.guard';

const salesMarketingModule = () => import('./sales-marketing.module').then((m) => m.SalesMarketingModule);

export const salesMarketingRoutes: Routes = [
  {
    path: 'sales-marketing',
    canActivateChild: [RoleGuard],
    loadChildren: salesMarketingModule,
    data: {
      enum: 'SALES_MARKETING_PROGRAM',
      label: 'Sales & Marketing',
      icon: 'ic_marketing_promo.svg',
      activeClass: 'active',
      children: [
        {
          enum: 'DISCOUNT_SETTING',
          label: 'Discount Setting',
          path: 'sales-marketing/discount-setting/sales',
          children: [
            {
              enum: 'SALES_DISCOUNT',
              label: 'Sales Discount',
              path: 'sales-marketing/discount-setting/sales',
              children: [],
            },
            {
              enum: 'CBD_DISCOUNT',
              label: 'CBD Discount',
              path: 'sales-marketing/discount-setting/cbd',
              children: [],
            },
          ],
        },

        {
          enum: 'TARGET_DISTRIBUTOR_SETTING',
          // devBypass: true, // DEV ONLY — remove when RBAC contract is active
          label: 'Target Distributor',
          path: 'sales-marketing/target-distributor/list',
          children: [],
        },

        {
          enum: 'PROGRAM_MARKETING_SETTING',
          label: 'Program Marketing Distributor',
          path: 'sales-marketing/program-marketing/list',
          children: [],
        },

        {
          enum: 'PROGRAM_MARKETING_SETTING',
          label: 'Program Marketing Retailer',
          path: 'sales-marketing/program-marketing-retailer/list',
          children: [],
        },
      ],
    },
  },
];
